'use client'
import axios from "axios"
import { useCookies } from "next-client-cookies"
import { useTranslations } from "next-intl"
import { useEffect, useState } from "react"

// Error boundaries must be Client Components

export default function Error({ error, reset, }: { error: Error & { digest?: string }, reset: () => void }) {
  const t = useTranslations("EditProject")
  const cookies = useCookies()

  const [token, setToken] = useState<string>()
  const [hasSentError, setHasSentError] = useState(false)

  // Auto-reload on ChunkLoadError (happens after deploy when old JS chunks are gone)
  useEffect(() => {
    if (error?.name === 'ChunkLoadError' || error?.message?.includes('Loading chunk')) {
      const hasReloaded = sessionStorage.getItem('chunk_reload')
      if (!hasReloaded) {
        sessionStorage.setItem('chunk_reload', '1')
        window.location.reload()
        return
      }
      sessionStorage.removeItem('chunk_reload')
    }
  }, [error])

  useEffect(() => {
    const token = localStorage.getItem("token_frame") || cookies.get("token")
    setToken(token)
  }, [error])

  useEffect(() => {
    if (token && !hasSentError) {
      const formData = new FormData()
      const currentUrl = typeof window !== 'undefined'
      ? window.location.href
      : 'unknown';
      console.log("MESSAGE : "+`${currentUrl} : ${error.message} || ${error.stack}`)
      formData.append("log", `${currentUrl} : ${error.message} || ${error.stack}`)

      axios.post("https://vexub.fr/api/vexub_v2/video/logError.php", formData, { headers: { Authorization: `Bearer ${token}` } }).then((data) => {
        console.log(data.data)
      })
      setHasSentError(false)
    }
  }, [token])

  return (
    <div className='overflow-hidden w-screen h-full flex items-center justify-center flex-col gap-3'>
      <h2 className='font-bold'> {t("ErrorEditProject")}</h2>
      <p>{t("ErrorEditProject2")}</p>
      <button
        className='bg-secondary-500 p-2 rounded-full z-1000000'
        onClick={ () => {reset()} }
      >
        {t("Retry")}
      </button>
    </div>
  )
}